export default "__VITE_ASSET__5OkIB8VI__"